import LocalStorage from '../LocalStorage';

const key = 'pwa_mode';

export const setToPwaMode = (): void => LocalStorage.set(key, 'true');

export const isInPwaMode = (): boolean => !!LocalStorage.get(key);
